(() => {
  const root = document.querySelector('[data-collection-page]');
  if (!root) return;

  const sortSelect = root.querySelector('[data-collection-sort]');
  sortSelect?.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });

  root.querySelectorAll('.filter-form:not(.filter-form--mobile) [data-filter-input]').forEach((input) => {
    if (input.type === 'number') return;
    input.addEventListener('change', () => input.form?.submit());
  });

  const openButton = root.querySelector('[data-filter-drawer-open]');
  const drawer = root.querySelector('[data-filter-drawer]');
  const overlay = root.querySelector('[data-filter-drawer-overlay]');
  const closeButton = root.querySelector('[data-filter-drawer-close]');
  if (!openButton || !drawer || !overlay) return;

  const openDrawer = () => {
    overlay.hidden = false;
    requestAnimationFrame(() => {
      overlay.classList.add('is-visible');
      drawer.classList.add('is-open');
    });
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('filter-drawer-open');
    closeButton?.focus();
  };

  const closeDrawer = () => {
    overlay.classList.remove('is-visible');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    openButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('filter-drawer-open');
    window.setTimeout(() => { overlay.hidden = true; }, 220);
  };

  openButton.addEventListener('click', openDrawer);
  closeButton?.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
})();
